import { render, staticRenderFns } from "./highlights-menu.vue?vue&type=template&id=8c80d082"
import script from "./highlights-menu.vue?vue&type=script&lang=js"
export * from "./highlights-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/highlights-menu/highlights-menu.vue
// module id = gIb1
// module chunks = 0